import {useMutation} from "@tanstack/react-query";
import {useFeedbackTools} from "../../components/FeedbackTools";
import * as api from "../../services/api";


export const useArchiveApartmentMutation = ({apartmentId}) => {
    const {showSuccessNotification} = useFeedbackTools();

    return useMutation({
        mutationFn: async () => await api.Apartments.archiveApartment(apartmentId),
        onSuccess: () => {
            showSuccessNotification("Appartamento eliminato con successo");
        }
    });
}

export const useArchiveHomeMutation = ({homeId}) => {
    const {showSuccessNotification} = useFeedbackTools();

    return useMutation({
        mutationFn: async () => await api.Homes.archiveHome(homeId),
        onSuccess: () => {
            showSuccessNotification("Struttura eliminata con successo");
        }
    });
}